/**
 * Booking deposit payment status — verifies a Stripe checkout after the
 * success redirect lands back on /bookings?payment=success&session_id=...
 *
 * The deployed backend route is GET /payments/status/{session_id}. Besides
 * reporting the Stripe payment status, that route confirms the inquiry and
 * blocks the booked dates on the calendar, so the poll must hit it exactly.
 */
import api from './api';

export function buildPaymentStatusPath(sessionId) {
  return `/payments/status/${sessionId}`;
}

/**
 * The backend relays Stripe's session payment_status; "paid" is the only
 * value that confirms the deposit.
 */
export function isPaymentConfirmed(statusPayload) {
  return statusPayload?.payment_status === 'paid';
}

export const bookingDepositStatusAPI = {
  get: (sessionId) => api.get(buildPaymentStatusPath(sessionId)),
};
